<template>
  <div id="kpfuiApp" ref="kpfuiAPP">

    <!-- <div class="version-container">
      <small>v.{{VERSION}}</small>
    </div> -->

    <Model />

    <QuestionContainer />

    <div id="loadingContainer">
      <Loading :loadingFlag="loadingFlag" />
    </div>
  </div>
</template>

<script>
import Model from '@/components/Model.vue';
import QuestionContainer from "@/components/QuestionContainer.vue";
import Loading from '@/components/Loading.vue';

import { mapGetters } from 'vuex';

export default {
  name: 'app',
  components: {
    Model,
    QuestionContainer,
    Loading
  },
  data(){
    return {
    }
  },
  created(){
    console.debug('VERSION', this.VERSION);
  },
  computed:{
    ...mapGetters({
      loadingFlag: "getLoadingFlag",
      VERSION: 'getVersion'
    })
  }
}
</script>

<style lang="scss">
@import "styles/basics.scss";
@import "styles/layout.scss";

#kpfuiApp {
  @import 'node_modules/bootstrap/scss/bootstrap';
  @import 'node_modules/bootstrap-vue/src/index.scss';
  
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  position: relative;
  overflow-x: hidden;

  background: $blue;

  #loadingContainer{
    position: absolute;
    top: 0;
    height: 20%;
    width: 100%;

    pointer-events: none;
  }

  .version-container{
    position: absolute;
    top: 2px;
    left: 2px;

    font-size: 0.6rem;

    color: $white;

    z-index: 100;
  }
}
</style>
